import React from 'react';

export type ToggleProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
};

export function Toggle({ checked, onChange, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        width: 51, height: 31, borderRadius: 999,
        background: checked ? 'var(--success)' : 'var(--bg-fill-3)',
        position: 'relative', padding: 2,
        transition: 'background var(--dur-base) var(--ease-out)',
        border: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <span
        style={{
          position: 'absolute', top: 2, left: checked ? 22 : 2,
          width: 27, height: 27, borderRadius: 999,
          background: '#fff',
          boxShadow: '0 3px 8px rgba(0,0,0,.15), 0 1px 1px rgba(0,0,0,.1)',
          transition: 'left var(--dur-base) var(--ease-spring)',
        }}
      />
    </button>
  );
}

export default Toggle;
